<template>
	<div class="page">
		<!-- your page -->
		<div class="floor" v-for="(item,index) in commodity" :key="index">
			<div class="floorTitle">
				<div class="floorTitleBox">
					<img :src="item.titleIcon" alt="">
				</div>
				<div class="floorTitleInfo">
					{{item.floorInfo}}
				</div>
				<div class="floorMore" @click="floorMore" :data-id="item.id">
					查看更多>
				</div>
			</div>
			<div class="floorCont">
				<div class="floorLeft">
					<img :src="item.leftBack" alt="">
				</div>
				<div class="floorMid">
					<div class="midSwiper">
						<el-carousel trigger="click" height="674px" :interval="interval">
							<el-carousel-item v-for="(tab,tabIndex) in item['unitCommodity']" :key="tabIndex">
								<div class="floorBlock">
									<div class="floorItem" v-for="(unit,unitIndex) in tab['block']" :key="unitIndex" @click="goParticulars" :data-id="unit.id">
										<div class="itemAvatar" :data-id="unit.id">
											<img :src="unit.image_id" alt="" :data-id="unit.id">
										</div>
										<div class="itemName" :data-id="unit.id">
											{{unit.name}}
										</div>
										<div class="itemPrice" :data-id="unit.id">
											<div class="priceBox" :data-id="unit.id">
												¥{{unit.price}}
											</div>
											<div class="sales" :data-id="unit.id">
												销量:{{unit.buy_count}}
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<!-- <div class="floorRight">
					<div class="rightTop">
						精选品牌
					</div>
					<div class="brandList">
						<div class="brandItem" v-for="(tab,tabIndex) in item['brand']" :key="tabIndex" :data-id="tab.id" :data-name="tab.name">
							<div class="brandBox" :data-id="tab.id" @click="goType">
								<img :src="tab.logo" alt="" :data-id="tab.id">
							</div>
						</div>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'commodity',
		data(){
			return {
				commodity:[],
				interval:5000
			}
		},
		methods:{
			goType(e){
				var id = e.target.dataset.id
				this.$router.push({path:'/type',query:{brand:id,type:'brand'}})
			},
			floorMore(e){
				var id = e.target.dataset.id
				this.$router.push({path:'/type',query:{catid:id,type:'catid'}})
			},
			goParticulars(e){
				var id = e.currentTarget.dataset.id
				this.$router.push({path:"/particulars",query:{cid:id,from:'normal'}})
			},
			fetchData(){
				var data = {
					"method":"classifiedDisplay.positionClassifiedList"
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var list = res.data
						var array = new Array()
						for (var i = 0; i < list.length; i++) {
							var item = list[i]
							var obj = {
								titleIcon:item.image_id,
								floorInfo:item.name,
								id:item.id,
								leftBack:item.bigimage_id,
								unitCommodity:[
									{
										block:item.unitCommodity_one
									},
									{
										block:item.unitCommodity_two
									}
								],
								brand:item.brand
							}
							array.push(obj)
						}
						that.commodity = array
					}else{
						that.globalTest('classifiedDisplay.positionClassifiedList','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.floor{
		width: 100%;
	}
	.floorTitle{
		width: 100%;
		height: 80px;
		line-height: 80px;
	}
	.floorTitleBox{
		width: 170px;
		height: 100%;
		float: left;
	}
	.floorTitleBox img{
		display: block;
		margin-top: 23px;
		height: 34px;
	}
	.floorTitleInfo{
		font-size: 18px;
		color: #838383;
		width: 300px;
		height: 100%;
		float: left;
	}
	.floorMore{
		width: 100px;
		font-size: 14px;
		text-align: right;
		float: right;
		color: #838383;
		cursor: pointer;
	}
	.floorMore:hover{
		color: #036DEE;
	}
	.floorCont{
		width: 100%;
		height: 674px;
	}
	.floorLeft{
		width: 259px;
		float: left;
		height: 100%;
		box-shadow: 3px 3px 3px #E3E3E3;
		cursor: pointer;
	}
	.floorLeft img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.floorMid{
		width: 910px;
		height: 100%;
		float: left;
		margin-left: 30px;
		border: 1px solid #E3E3E3;
		box-sizing: border-box;
		box-shadow: 3px 3px 3px #E3E3E3;
		background: #FFFFFF;
	}
	.floorBlock{
		width: 100%;
		height: 650px;
	}
	.floorItem{
		width: 206px;
		height: 48%;
		float: left;
		margin-left: 14px;
		margin-top: 1.2%;
		cursor: pointer;
	}
	.itemAvatar{
		width: 100%;
		height: 210px;
		overflow: hidden;
	}
	.itemAvatar img{
		width: 100%;
	}
	.itemName{
		width: 100%;
		height: 50px;
		line-height: 25px;
		overflow: hidden;
	}
	.floorItem:hover .itemName{
		color: #036DEE;
	}
	.floorItem:hover .itemAvatar{
		border: 1px solid #F9F9F9;
		box-sizing: border-box;
	}
	.floorItem:hover .itemAvatar img{
		animation: floorItem 0.3s 1;
		animation-fill-mode: forwards;
	}
	@keyframes floorItem{
		from{width: 100%;}
		to{
			display: block;
			width: 106%;
			margin-top: -3%;
			margin-left: -3%;
		}
	}
	.itemPrice{
		width: 100%;
		height: 40px;
		line-height: 40px;
	}
	.priceBox{
		width: 60%;
		height: 100%;
		float: left;
		color: red;
		font-size: 20px;
		font-weight: bold;
	}
	.sales{
		width: 40%;
		height: 100%;
		float: left;
		font-size: 12px;
		text-align: right;
		color: #838383;
	}
	.floorRight{
		width: 200px;
		height: 100%;
		float: right;
		border: 1px solid #E3E3E3;
		box-sizing: border-box;
		box-shadow: 3px 3px 3px #E3E3E3;
		background: #FFFFFF;
	}
	.rightTop{
		width: 100%;
		height: 72px;
		line-height: 72px;
		text-align: center;
		font-size: 24px;
		color: #838383;
	}
	.brandList{
		width: 100%;
		height: 600px;
	}
	.brandItem{
		width:99px;
		height:100px;
		float: left;
	}
	.brandItem .brandBox{
		width: 84px;
		height: 84px;
		display: block;
		margin: 8px auto;
		border: 1px solid #E3E3E3;
		box-sizing: border-box;
		cursor: pointer;
		border-radius: 5px;
		overflow: hidden;
	}
	.brandItem .brandBox:hover{
		animation: borderchange 0.2s 1;
		border-radius: 5px;
		background: #F0F0F0;
		animation-fill-mode: forwards;
	}
	@keyframes borderchange{
		from{
			border: 1px solid #E3E3E3
		}
		to{
			border: 1px solid #036DEE;
		}
	}
	.brandBox img{
		width: 100%;
	}
</style>
